import React from 'react'
import { Alert } from '@material-ui/lab';
import { useServiceUnavailableStyles } from './service-unavailable.styles'

interface ServiceUnavailableProps {
  message: string;
  security?: string;
  onClose?: () => void;
}
export const ServiceUnavailable = (props: ServiceUnavailableProps): React.ReactElement => {
  const { message, security = 'error', onClose } = props
  const classes = useServiceUnavailableStyles()

  return <Alert className={classes.root} security={security} severity="error" onClose={() => { onClose?.() }}>
    {message}
  </Alert>
}
